<div id="info-dialog-container">
    <!-- Header -->
    <div class="d-flex justify-content-end">
        <!-- <div class="title margin-right-1">{{ title | translate }}</div> -->
        <button mat-icon-button color="warn" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
 
    
    <div class="flex-center">
        <img class="w-25 " [src]="data.message.from_user.profile_photo_path" />
    </div>

    <div class="d-flex flex-wrap justify-content-center text-center">
        
        <div class="title margin-right-1 margin-bottom-05">{{ data.message.from_user.name}}</div>
        <div class="mat-h4 margin-bottom-05 width-80">
            {{ data.message.content}}
        </div>

        <button mat-raised-button color="primary" class="margin-bottom-1" type="button" (click)="closeDialog()">Cerrar</button>
    </div>
</div>
